var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "#1177BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5C11.59 10.5 11.25 10.84 11.25 11.25V16.25C11.25 16.66 11.59 17 12 17C12.41 17 12.75 16.66 12.75 16.25V11.25C12.75 10.84 12.41 10.5 12 10.5Z",
    fill: "#1177BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.25109C11.87 7.25109 11.74 7.28109 11.62 7.33109C11.5 7.38109 11.39 7.45109 11.29 7.54109C11.2 7.64109 11.13 7.74109 11.08 7.87109C11.03 7.99109 11 8.12109 11 8.25109C11 8.38109 11.03 8.51109 11.08 8.63109C11.13 8.75109 11.2 8.86109 11.29 8.96109C11.39 9.05109 11.5 9.12109 11.62 9.17109C11.86 9.27109 12.14 9.27109 12.38 9.17109C12.5 9.12109 12.61 9.05109 12.71 8.96109C12.8 8.86109 12.87 8.75109 12.92 8.63109C12.97 8.51109 13 8.38109 13 8.25109C13 8.12109 12.97 7.99109 12.92 7.87109C12.87 7.74109 12.8 7.64109 12.71 7.54109C12.61 7.45109 12.5 7.38109 12.38 7.33109C12.26 7.28109 12.13 7.25109 12 7.25109Z",
    fill: "#1177BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.503c57430d916133a8b1da8ddb52fbef.svg";
export { ForwardRef as ReactComponent };